var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('download-excel',{staticClass:"btn btn-default",attrs:{"fetch":_vm.fetchData,"fields":_vm.json_fields,"worksheet":"Stock","name":_vm.nameFile,"before-generate":_vm.startDownload,"before-finish":_vm.finishDownload}},[_c('b-button',[(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_vm._v("\n       Descargar\n    ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }